<div class="input-group">
  <mat-form-field class="w-100">
    <input matInput #target [value]="value" [placeholder]="placeholder" readonly>
  </mat-form-field>
  <div class="input-group-button">
    <button mat-icon-button appClipboard [target]="target" (success)="handleSuccess()" (error)="handleError()" aria-label="Copy to clipboard" type="button">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/clipboard-copy/clipboard-copy.component.html